import http from "../http-common";
/* eslint-disable */
class TermAndConditionTelemedicineService {
  getTermAndCondition() {
    return http.get("/term-and-condition-telemedicine", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data, id) {
    var bodyFormData = new FormData();
    bodyFormData.append("remark", data.remark);

    if (id) bodyFormData.append("id", id);

    return http.post(`/term-and-condition-telemedicine`, bodyFormData, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new TermAndConditionTelemedicineService();
